import { buildCommonFilters, embedFilter } from '../sharedFilters'

const DATASET_KEY = 'operational_procedures'

const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: { label: 'REMS' },
  USER: { label: 'Usuario' },
  REGION: { column: 'regions.name', label: 'Estado' },
  MUNICIPALITY: { column: 'municipalities.name', label: 'Municipio' },
  SECTOR: { column: 'sectors.name', label: 'Región' },
  CENTER: { column: 'centers.name', label: 'Centro' },
  TENANT: false,
  STATUS: false,
})

export default {
  key: DATASET_KEY,
  label: 'Proced. Op. - Ejercicios Operativos',
  timeColumn: 'operational_procedures_form_answers.created_at',
  permission: { action: 'read', subject: 'OperationalProcedure' },

  tables: {
    operational_procedures_form_answers: ["id", "id_user", "id_operational_procedure", "id_template", "template_snapshot", "template_sources", "answers", "uuid", "data", "created_at", "updated_at"],
    operational_procedures: ["id", "id_user", "id_unit", "reference_number", "evaluation_date", "title", "description", "created_at", "updated_at"],
    operational_procedures_template: ["id", "id_tenant", "id_user", "uuid", "name", "data", "created_at", "updated_at"],
    operational_procedures_status: ["id", "id_user", "id_operational_procedure", "id_status", "created_at", "updated_at"],
    operational_procedures_status_catalog: ["id", "name", "created_at", "updated_at"],
    operational_procedures_form: ["id", "id_tenant", "id_user", "uuid", "name", "data", "created_at", "updated_at"],
    users: ["id", "id_unit", "id_maintenance_company", "image", "check_alarms", "frame_color", "id_profile", "user", "email", "password", "name", "first_name", "second_name", "config", "plate_number", "created", "updated", "active", "vpn_access", "allow_virtual_button_alarm", "allow_visual_notifications", "allowed_units_live_video_flows", "phone_number", "alarm_history_per_hours", "alarm_history_per_days", "alarm_history_by_records", "last_login", "video_wall", "active_sesion_video_wall", "id_country", "auth_two_factor_code", "auth_two_factor_time", "auth_two_factor_type", "verify_email_code", "verify_sms_code", "verify_sms", "verify_email", "online", "enabled_chat", "enabled_helpdesk"],
    units: ["id", "id_router", "description", "address_1", "address_2", "exterior_number", "suburb", "number", "postal_code", "id_country", "id_region", "id_sector", "active", "route", "plate_number", "vin", "driver", "provider", "owner", "company", "vehicle", "allow_virtual_button_alarm", "reaction_patrol", "id_alarms_levels", "active_digital_output", "needs_check", "id_municipality", "time_zone", "data", "comments", "id_category", "id_seproban", "rems", "sirh", "created_at", "updated_at"],
    sectors: ["id", "id_center", "name", "alcaldia", "provider", "created", "updated"],
    centers: ["id", "tenant_id", "name", "description", "updated", "created", "active"],
    regions: ["id", "name", "code", "country_id", "acronym", "created_at", "updated_at"],
  },

  defaults: {
    field: 'units.description',
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'timeseries', label: 'Tendencia' },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  csvConfig: {
    withTables: 'operational_procedures_form_answers',
    columns: 'operational_procedures_form_answers.updated_at,operational_procedures.reference_number,operational_procedures.evaluation_date,operational_procedures.title,operational_procedures.description,operational_procedures.created_at,operational_procedures.updated_at,operational_procedures_template.name,operational_procedures_template.created_at,operational_procedures_template.updated_at,operational_procedures_status.created_at,operational_procedures_status.updated_at,operational_procedures_status_catalog.name,operational_procedures_status_catalog.created_at,operational_procedures_status_catalog.updated_at,operational_procedures_form.name,operational_procedures_form.data,operational_procedures_form.created_at,operational_procedures_form.updated_at,users.user,users.name,users.email,units.description,units.active,municipalities.name,sectors.name,regions.name,operational_procedures_form_answers.data',
    exceptColumns: 'operational_procedures_template.name,operational_procedures_form.name,operational_procedures.title',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
    //timeseries: { trendline: true },
  },

  fields: [
    { key: 'operational_procedures_form_answers.data', label: 'Formulario - Procesos Operativos', processForm: true },
    { key: 'users.user', label: 'Usuario' },
    { key: 'users.name', label: 'Nombre usuario' },
    { key: 'users.id_profile', label: 'Perfil' },
    { key: 'users.email', label: 'Email usuario' },
    { key: 'units.description', label: 'REMS' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'operational_procedures.evaluation_date', label: 'Fecha evaluación', defaultParams: { freq: '1mo' } },
    { key: 'operational_procedures.created_at', label: 'Fecha de creación', defaultParams: { freq: '1mo' } },
    { key: 'operational_procedures.updated_at', label: 'Fecha de actualización', defaultParams: { freq: '1mo' } },
    { key: 'operational_procedures_status_catalog.name', label: 'Estatus' },
  ],

  filters: [
    ...commonFilters,
    {
      key: 'question',
      label: 'Preguntas del formulario',
      forField: 'Preguntas del formulario',
      filterType: 'process-form',
      optionsConfig: {
        type: 'json-keys',
        dataset: 'operational_procedures',
        column: 'operational_procedures_form_answers.data',
        limit: -1,
      },
    },
    embedFilter(DATASET_KEY, 'operational_procedures_status_catalog.name', 'Estatus', 'status'),
    embedFilter(DATASET_KEY, 'users.user', 'SOEID', 'user_username'),
    embedFilter(DATASET_KEY, 'users.name', 'Nombre usuario', 'user_name'),
    embedFilter(DATASET_KEY, 'users.email', 'Email usuario', 'user_email'),

    {
      key: 'procedure_created_at',
      label: 'Fecha de creación',
      filterType: 'where-date',
      whereColumn: 'operational_procedures.created_at',
      optionsConfig: { type: 'date' },
    },
    {
      key: 'procedure_updated_at',
      label: 'Fecha de actualización',
      filterType: 'where-date',
      whereColumn: 'operational_procedures.updated_at',
      optionsConfig: { type: 'date' },
    },
  ],

  dateGrouping: {
    column: 'procedure_created_at.created_at',
    presets: [
      { value: '1d', label: 'Día' },
      { value: '1W', label: 'Semana' },
      { value: '1M', label: 'Mes' },
      { value: '1Y', label: 'Año' },
    ],
  },
}
